import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-input',
  template: `
    <div class="dynamic-field form-group form-input" [formGroup]="group">
      <label>{{ config.label }}</label>
      <input
        type="text"
        class="form-control"
        [attr.placeholder]="config.placeholder"
        [formControlName]="config.name" />
    </div>
  `,
})
export class FormInputComponent {
  config;
  group: FormGroup;
}

